import { useMemo, useState } from 'react';

import { useContainerWidth } from 'lib/hooks/useContainerWidth';

import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

import { PREVIEW_TABS, getPreviewLayout } from '../../lib/constants';
import { buildPreviewVars, isDefaultBranding, isTwoColor, resolveBranding } from '../../lib';

import CheckinPreview from './CheckinPreview';
import AppointmentEmailPreview from './AppointmentEmailPreview';

const TABS = PREVIEW_TABS.map(({ label, shortLabel, ...item }) => ({
  ...item,
  label: (
    <>
      <span className="sm:hidden">{label}</span>
      <span className="hidden sm:inline">{shortLabel}</span>
    </>
  )
}));

const LivePreview = ({ draft, practice }) => {
  const [tab, setTab] = useState(PREVIEW_TABS[0].value);
  const [paneRef, paneWidth] = useContainerWidth();
  const layout = useMemo(() => getPreviewLayout(paneWidth), [paneWidth]);
  const previewVars = useMemo(() => buildPreviewVars(draft), [draft]);
  const resolved = resolveBranding(draft);
  const accentHex = isTwoColor(draft) ? resolved.secondary_color : null;

  return (
    <section className="flex min-w-0 flex-1 flex-col bg-white xs:flex-none">
      <div className="flex min-h-10 shrink-0 items-center gap-4 border-0 border-b border-solid border-neutral-200 px-4 sm:gap-3 sm:py-2">
        <span
          className="block h-3 w-3 rounded-full bg-success-500 shadow-[0_0_0_4px_rgba(22,179,100,0.16)]"
          aria-hidden="true"
        />
        <p className="text-base font-500 leading-6 text-neutral-800">Live preview</p>
        <SegmentedControl
          items={TABS}
          active={tab}
          onClick={(item) => setTab(item.value)}
          disableOverflow
          className="h-7 bg-neutral-75"
        />
      </div>
      {/* Static mock: the actions inside only demonstrate how the brand colors render. */}
      <div
        className="min-h-0 flex-1 overflow-y-auto p-5 sm:p-4 xs:flex-none xs:overflow-visible"
        style={previewVars}
        aria-label="Brand colors preview"
        aria-live="polite">
        <div ref={paneRef} className="pointer-events-none select-none" aria-hidden="true">
          {tab === 'checkin' ? (
            <CheckinPreview isDefaultBrand={isDefaultBranding(draft)} layout={layout} />
          ) : (
            <AppointmentEmailPreview
              practice={practice}
              primaryHex={resolved.primary_color}
              accentHex={accentHex}
              isTiny={layout.isTiny}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default LivePreview;
